import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { Subject } from 'rxjs';
import { ComponentNameEnum, NavigationEntry } from '../../models/navigation.model';

@Component({
  selector: 'expressions-editor-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: false,
})
export class NavigationComponent {
  @Output() onNavigationChange: EventEmitter<ComponentNameEnum> = new EventEmitter<ComponentNameEnum>();
  @Output() onSetNavMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() width: number;
  public navigationEntries: NavigationEntry[];

  private resAsync: Promise<ResourceSet>;
  private previousSelectedEntry: NavigationEntry | undefined;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private resourcesService: ResourceManagerService) {
    this.resAsync = this.resourcesService.getResourceSet('abc-opath-expressions');
  }

  async ngOnInit(): Promise<void> {
    await this.createNavigationEntries();
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private async createNavigationEntries(): Promise<void> {
    this.navigationEntries = [
      {
        componentName: ComponentNameEnum.EntityComponent,
        icon: 'edit',
        toolTip: (await this.resAsync).get('attribute-title'),
        isSelected: true,
      },
      {
        componentName: ComponentNameEnum.FunctionComponent,
        icon: 'formula',
        toolTip: (await this.resAsync).get('functions-title'),
        isSelected: false,
      },
      {
        componentName: ComponentNameEnum.OperatorsComponent,
        icon: 'codeblock',
        toolTip: (await this.resAsync).get('operators-title'),
        isSelected: false,
      },
      {
        componentName: ComponentNameEnum.ParametersComponent,
        icon: 'preferences',
        toolTip: (await this.resAsync).get('parameter-title'),
        isSelected: false,
      },
      {
        componentName: ComponentNameEnum.SearchComponent,
        icon: 'search',
        toolTip: (await this.resAsync).get('search-title'),
        isSelected: false,
      },
      {
        componentName: ComponentNameEnum.ValidateComponent,
        icon: 'selectall',
        toolTip: (await this.resAsync).get('validation-title'),
        isSelected: false,
      },
      {
      componentName: ComponentNameEnum.OpathGeneratorComponent,
      icon: 'assets/images/ai.svg',
      toolTip: (await this.resAsync).get('generator-title'),
      isSelected: false,
      }
    ];
  }

  public setNavMenu(visible: boolean): void {
    this.onSetNavMenu.emit(visible);
  }

  public async loadComponent(navigationEntry: NavigationEntry): Promise<void> {
    if (navigationEntry.componentName === this.previousSelectedEntry?.componentName) {
      this.setNavMenu(false);
      this.previousSelectedEntry = undefined;
    } else {
      this.setNavMenu(true);
      this.previousSelectedEntry = navigationEntry;
      this.navigationEntries.forEach((x) => {
        if (x.componentName !== navigationEntry.componentName) {
          x.isSelected = false;
        } else {
          x.isSelected = true;
        }
      });
    }
    this.onNavigationChange.emit(navigationEntry.componentName);
  }
}
